import { render, staticRenderFns } from "./record_priority.vue?vue&type=template&id=faa5390c&"
import script from "./record_priority.vue?vue&type=script&lang=js&"
export * from "./record_priority.vue?vue&type=script&lang=js&"
import style0 from "./record_priority.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports